import React from 'react';
import { Anchor, Text } from '@mantine/core';

interface CitationLinkProps {
  id: string | number;
  callType: 'quote' | 'recommend'; // Assuming these are the possible call types based on App.tsx usage
  citations: any; // Keeping this generic for now
  children?: React.ReactNode;
  className?: string;
}

export const CitationLink = ({ id, callType, citations, children, className }: CitationLinkProps) => {
  // Basic placeholder rendering - you might want to extract title/url from citations[id]
  const citation = citations && citations[id] ? citations[id] : null;
  const text = citation ? citation.title || `Citation ${id}` : `Citation ${id}`;

  return (
    <Anchor 
      href={citation?.url || '#'} 
      target="_blank" 
      // rel="noopener noreferrer" // Mantine Anchor handles this
      className={className} 
      title={citation?.content || `Content for citation ${id}`}
      underline="always"
    >
      {children || text} <Text span size="xs" c="dimmed">[{id}]</Text>
    </Anchor>
  );
}; 